import script from "./MedicalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicalPage.vue?vue&type=script&setup=true&lang=js"

import "./MedicalPage.vue?vue&type=style&index=0&id=ce1258d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce1258d2"]])

export default __exports__